import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  CriarInstanciaRequest,
  CriarInstanciaResponse,
  StatusInstanciaResponse,
  QrCodeResponse,
  DeletarInstanciaResponse
} from '../models/whatsapp-instancia.model';

/**
 * Serviço para gerenciamento de instâncias WhatsApp
 * Segue a documentação: GUIA-FRONTEND-ANGULAR-WHATSAPP-INSTANCIAS.md
 */
@Injectable({
  providedIn: 'root'
})
export class WhatsAppInstanciaService {
  private baseUrl = `${environment.apiUrl}/v1/WhatsAppInstancias`;

  constructor(private http: HttpClient) {}

  /**
   * Criar/inicializar uma nova instância WhatsApp para o tenant autenticado
   * POST /api/v1/WhatsAppInstancias/instances
   */
  criarInstancia(webhookUrl?: string): Observable<CriarInstanciaResponse> {
    const headers = this.getAuthHeaders();
    const body: CriarInstanciaRequest = { webhookUrl };

    return this.http.post<CriarInstanciaResponse>(
      `${this.baseUrl}/instances`,
      body,
      { headers }
    );
  }

  /**
   * Obter status atual da conexão WhatsApp
   * GET /api/v1/WhatsAppInstancias/instances/{sessionId}/status
   */
  obterStatus(sessionId: string): Observable<StatusInstanciaResponse> {
    const headers = this.getAuthHeaders();
    
    return this.http.get<StatusInstanciaResponse>(
      `${this.baseUrl}/instances/${sessionId}/status`,
      { headers }
    );
  }

  /**
   * Obter QR Code atual para conectar o WhatsApp (se disponível)
   * Também cria/inicia a instância caso ela não exista
   * GET /api/v1/WhatsAppInstancias/instances/{sessionId}/qr
   */
  obterQrCode(sessionId: string): Observable<QrCodeResponse> {
    const headers = this.getAuthHeaders();
    
    return this.http.get<QrCodeResponse>(
      `${this.baseUrl}/instances/${sessionId}/qr`,
      { headers }
    );
  }

  /**
   * Desconectar e remover a instância WhatsApp
   * DELETE /api/v1/WhatsAppInstancias/instances/{sessionId}
   */
  deletarInstancia(sessionId: string): Observable<DeletarInstanciaResponse> {
    const headers = this.getAuthHeaders();
    
    return this.http.delete<DeletarInstanciaResponse>(
      `${this.baseUrl}/instances/${sessionId}`,
      { headers }
    );
  }

  /**
   * Obter headers de autenticação com JWT Bearer Token
   */
  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('accessToken') || localStorage.getItem('jwt_token');
    return new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
  }
}
